import { Notification } from '@mantine/core'
import { IconInfo } from 'components/icons/IconInfo'
import type { FC } from 'react'
import React, { useState } from 'react'
import { colors } from 'settings/colors'

export const LegacyRedirectBanner: FC<{
  children: React.ReactNode
  // pinned to the top of the nearest positioned ancestor instead of the viewport;
  // used when rendered below the maintenance banner, which already handles the safe area
  contained?: boolean
}> = (props) => {
  const [display, setDisplay] = useState(true)

  const onBannerClose = () => {
    setDisplay(false)

    // Remove 'source' param from URL only when user closes the banner
    // we want to display the banner on refreshes until user closes it
    const searchParams = new URLSearchParams(window.location.search)

    if (searchParams.has('source')) {
      searchParams.delete('source')

      const newSearch = searchParams.toString()
      const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '')

      window.history.replaceState({}, '', newUrl)
    }
  }

  if (!display) return null

  return (
    <Notification
      icon={
        <span css={{ fontSize: 28, color: colors.blue800, backgroundColor: colors.white, paddingTop: 6 }}>
          <IconInfo />
        </span>
      }
      css={{
        position: props.contained ? 'absolute' : 'fixed',
        paddingTop: props.contained ? 10 : 'calc(env(safe-area-inset-top) + 10px)',
        top: 0,
        zIndex: 10002,
        width: '100%',
        border: 'none',
        borderRadius: 0,
      }}
      onClose={onBannerClose}
    >
      {props.children}
    </Notification>
  )
}
